import React from 'react'

import {
  AppearingWrapper,
  CTAHeadline,
  SectionContainer,
} from 'Components/Blocks'
import { Button, Column, Text } from 'Components/UI'

import {
  LANDING_CONTENT_PX,
  LANDING_CONTENT_WIDTH_PX,
  LANDING_SECTION_GAP,
  LANDING_SECTION_PY,
} from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import CheckboxList from './CheckboxList'
import Statistic from './Statistic'
import Title from './Title'

type Props = {
  onAction?: () => void
}

function GrowYourNetworkSection({ onAction }: Props) {
  const { isMobile } = useResponsiveLayout()

  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Column
          alignCenter
          fullWidth
          gap={LANDING_SECTION_GAP}
          maxWidth={LANDING_CONTENT_WIDTH_PX}
          py={LANDING_SECTION_PY}
        >
          <Title />

          <CheckboxList />

          <Statistic />

          <CTAHeadline
            centered
            text={
              <>
                You’ve built a successful business, now it’s your time to&nbsp;
                <Text as="span" bold screen24 success>
                  enjoy
                </Text>
                &nbsp;what you have built while still generating opportunities
                to&nbsp;
                <Text as="span" bold screen24 success>
                  add value to your business
                </Text>
                .
              </>
            }
          />

          <Button large width={isMobile ? 1 : undefined} onClick={onAction}>
            Book a Meeting
          </Button>
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default GrowYourNetworkSection
